import React from 'react';
import { ClickLinkDataParamType } from '@rmc/webcx-web-libs';
import { useGetDomNode } from '../../hooks/useGetDomNode';
import { useAppear } from '../../hooks/useAppear';
import { AppUserInterface } from '../AppUserInterface';
import { ReplacementType } from '../../lib/REST/types';
import { Portal } from '../Portal';
import { DefaultContentTracker } from '../DefaultContentTracker';

type SelectorPortalCommonType = {
	isDefaultContent: boolean;
	clickLinkData: ClickLinkDataParamType;
	forceSetInterval?: boolean;
	getComment?: (prevHTML: string) => string;
	onAppear?: () => void;
	onRendered?: () => void | undefined;
};

type SelectorPortalPropsType = SelectorPortalCommonType & ReplacementType;

export function SelectorPortal({
	component,
	selector,
	clickLinkData,
	isDefaultContent,
	forceSetInterval = false,
	getComment = () => '',
	onAppear = () => {},
	onRendered = () => {},
}: SelectorPortalPropsType) {
	const isContentToReplace = !!component;

	const portalContainer = useGetDomNode({
		selector,
		forceSetInterval,
	});

	useAppear(portalContainer, onAppear);

	if (!portalContainer) {
		return null;
	}

	if (!isDefaultContent && !isContentToReplace) {
		return null;
	}

	if (isDefaultContent) {
		return (
			<DefaultContentTracker
				portalContainer={portalContainer}
				onRendered={onRendered}
				clickLinkData={clickLinkData}
			/>
		);
	}

	if (component === null || component === undefined) {
		return null;
	}

	return (
		<Portal
			selector={selector}
			portalContainer={portalContainer}
			component={
				<AppUserInterface
					component={component}
					clickLinkData={clickLinkData}
					onRendered={onRendered}
				/>
			}
			getCommentMessage={getComment}
		/>
	);
}
